import { CollectionType } from '@enums/CollectionType';

export const ContentTypes = [
  // Layout entities
  'collection',
  'menu',
  'page',

  // Base
  'image',
  'link',
  'title',
  'unmanaged',

  // Collection types
  CollectionType.QUERY,
  CollectionType.CHERRY_PICK,

  // Rest
  'grid',
  'pageSection',
  'rootMenu',
  'swimlane',
] as const;

export type ContentType = (typeof ContentTypes)[number];

export const LayoutEntityTypes = [
  'collection',
  'menu',
  'page',
] as const satisfies ReadonlyArray<ContentType>;

export type LayoutEntityType = (typeof LayoutEntityTypes)[number];

export const BaseContentTypes = [
  ...LayoutEntityTypes,
  'image',
  'link',
  'title',
  'unmanaged',
] as const satisfies ReadonlyArray<ContentType>;

export type BaseContentType = (typeof BaseContentTypes)[number];

export const MenuTypes = ['menu', 'rootMenu'] as const satisfies ReadonlyArray<ContentType>;
export type MenuType = (typeof MenuTypes)[number];

export const PageContentTypes = [
  ...Array.from(BaseContentTypes),
  ...Object.values(CollectionType),
] as const satisfies ReadonlyArray<ContentType>;

export type PageContentType = (typeof PageContentTypes)[number];

export const entityTypeGuard = (contentType: ContentType): contentType is LayoutEntityType =>
  (LayoutEntityTypes as ReadonlyArray<string>).includes(contentType);

export const baseContentTypeTypeGuard = (
  contentType: ContentType
): contentType is BaseContentType =>
  (BaseContentTypes as ReadonlyArray<string>).includes(contentType);

export const collectionTypeGuard = (contentType: ContentType): contentType is CollectionType =>
  (Object.values(CollectionType) as string[]).includes(contentType);

export const pageContentTypeTypeGuard = (
  contentType: ContentType
): contentType is PageContentType =>
  (PageContentTypes as ReadonlyArray<string>).includes(contentType);
